import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import styled from '@mui/system/styled';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import ChevronRight from "../icons/ChevronRight";
import useTranslation from 'next-translate/useTranslation';

interface BannerResultProps {
  resultNumber?: number;
  orderList: any[];
  selectedOrderBy: string,
  storeData: {
    storeId: string
    langId: string
    catalogId: string
    locale: string
    categoryId: string,
    orderBy: string,
    pageNumber: string,
    pageSize: string
  }
  handleFilter: Function
}

const StyledTitle = styled(Typography)({
  fontSize: '16px',
  letterSpacing: '0.1px',
  lineHeight: '24px',
});

const StyledFormControl = styled(FormControl)({
  minWidth: '145px',
  '.MuiOutlinedInput-notchedOutline': {
    border: '0',
  },
  '.MuiSelect-select': {
    border: '1px solid #e4e4e4',
    borderRadius: '12px!important',
    padding: '10px',
    color: '#606060',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0',
    '&[aria-expanded="true"] ~ svg': {
      transform: 'rotate(-90deg)',
    }
  },
  'svg': {
    width: '12px',
    height: '12px',
    color: '#606060',
    transform: 'rotate(90deg)',
    position: 'absolute',
    right: '10px',
    transition: 'transform 0.4s'
  },
});

const BannerResult: React.FC<BannerResultProps> = ({ resultNumber = 0, orderList , selectedOrderBy, storeData, handleFilter}) => {
  const { t } = useTranslation('common');
  let qtyResult = resultNumber === 0 ?
    t('find-results_0', {}, {default: 'Nessun risultato trovato'}):
    t('results', {}, {default: 'Risultati'});

  const handleChange = (event: SelectChangeEvent) => {
    //setOrderBy(event.target.value as string);
    let queryParams = {
      storeId: storeData.storeId,
      langId: storeData.langId,
      catalogId: storeData.catalogId,
      locale: storeData.locale,
      categoryId: storeData.categoryId,
      pageNumber: storeData.pageNumber,
      pageSize: storeData.pageSize,
      orderBy: event.target.value
    }
    handleFilter(queryParams);
  };

  return <Grid item xs={12}>
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <StyledTitle>{resultNumber > 0 ? resultNumber : ''} {qtyResult}</StyledTitle>
      {resultNumber > 0 && (
      <StyledFormControl>
        <Select
          labelId="select-order-by-label"
          id="select-order-by"
          value={selectedOrderBy}
          label={t('order-by', {}, {default: 'Ordina per'})}
          onChange={handleChange}
          IconComponent={() => <ChevronRight />}
        >

          <MenuItem value={t('order-by', {}, {default: 'Ordina per'})} sx={{ display: 'none' }}>{t('order-by', {}, {default: 'Ordina per'})}</MenuItem>
          {orderList && orderList.length > 0 && orderList.map((singleOption, index) =>
            <MenuItem key={index} value={singleOption.value}>{singleOption.label}</MenuItem>)
          }
        </Select>
      </StyledFormControl>
      )}
    </Box>
  </Grid>
}

export default BannerResult;
